import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { disabled } from '../../state/operations/copy';
import copy_svg from '../../../assets/img/SVG_icons/Top/editing_model/clone_body.svg';
import { img } from '@phi/components';
import { clone_body } from '@frontend/geometry_and_math';
import CopyTooltip from './CopyTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const CopyIcon = copy_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Clone';
        },
    },

    methods: {
        onClick() {
            if (disabled.value)
                return;
            else
                clone_body();
        },
    },

    render() {
        return h(BarButton, {
            id: 'clone-body-button',
            wrapperId: 'clone-body-wrapper',
            onClick: this.onClick,
            disabled: disabled.value,
            active: false,
            selected: this.state.tut_stage === 7,
            tippy: 'left',
            help: 'clone_body',
        }, {
            label: () => 'Copy',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(copy_svg, this.alt),
            tooltip: CopyTooltip,
        });
    },
});
